var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIronButterfy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 35H47",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeDasharray: "4 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3164 43.6509V44.1508H37.0234H36.6928L36.5633 43.8465L32.7379 34.8529L26.2969 20.8078L19.2636 34.8744L19.1254 35.1508H18.8164H13.8164H13L13.371 34.4236L25.871 9.9236L26.3422 9L26.7715 9.9438L37.9161 34.4438L37.9206 34.454L40.1462 39.6508L45.3164 39.6509V40.1509V43.6509Z",
    fill: "#12B16E",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5V53.5",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 44.5H15.3249L15.4569 44.2031L19.4569 35.2031L19.7694 34.5H19H14H13.678L13.5448 34.7931L11.178 40H7H6.5V40.5V44V44.5H7H15Z",
    fill: "#E94C69",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7695 45H37.4446L37.3126 44.7031L33.3126 35.7031L33.0001 35H33.7695H38.7695H39.0915L39.2247 35.2931L41.5915 40.5H45.7695H46.2695V41V44.5V45H45.7695H37.7695Z",
    fill: "#E94C69",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIronButterfy);
export default __webpack_public_path__ + "static/media/iron_butterfy.d42e53c629af6a725113d9afe008dd2c.svg";
export { ForwardRef as ReactComponent };